import { gql } from '@apollo/client';
import Fragments from './fragments';

export const PAGED_REQUIRED_DOCUMENTS_QUERY = gql`
  query pagedRequiredDocuments($pager: PagerInputNew, $filters: RequiredDocumentsFilterInput) {
    pagedRequiredDocuments(pager: $pager, filters: $filters) {
      total
      values {
        ...requiredDocumentsItem
      }
    }
  }
  ${Fragments.requiredDocumentsItem}
`;
